var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTotal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.725,
    height: 19.963,
    viewBox: "0 0 19.725 19.963",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1109",
    "data-name": "Rectangle 1109",
    width: 19.725,
    height: 19.963,
    fill: "#2e117f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4431",
    "data-name": "Group 4431",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7440",
    "data-name": "Path 7440",
    d: "M158.047,7.835A10.093,10.093,0,0,0,150.269.042a.733.733,0,0,0-.887.714V8.721h7.95a.733.733,0,0,0,.715-.886",
    transform: "translate(-138.463 -0.024)",
    fill: "#2e117f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7441",
    "data-name": "Path 7441",
    d: "M154.084,141.15l4.893,6.2a.732.732,0,0,0,1.126.027,10.041,10.041,0,0,0,2.437-5.409.731.731,0,0,0-.726-.818Z",
    transform: "translate(-142.821 -130.833)",
    fill: "#2e117f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7442",
    "data-name": "Path 7442",
    d: "M14.159,18.177a.73.73,0,0,1-.34,1.069A10.083,10.083,0,1,1,8,.015a.729.729,0,0,1,.874.717V9.881Z",
    transform: "translate(-0.001 0)",
    fill: "#2e117f"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotal);
export default __webpack_public_path__ + "static/media/total.a5f7563623deaef753799993122f7a8b.svg";
export { ForwardRef as ReactComponent };